import React from 'react';
import PropTypes from 'prop-types';
import FontAwesome from 'react-fontawesome';
import SlotInfo from './SlotInfo';
import i18n from '../utils/i18n';
import './styles/UserBookedCourtCardComponent.scss';

const UserBookedCourtCardComponent = ({
  time,
  clubName,
  clubAddress,
  courtType,
  openCancellationConfirmModal,
  invitedBy
}) => (
  <div className="user-booked-court-card">
    <div className="lower-court-info">
      <div className="court-heading">
        {i18n.t('upcomingBookings.COURT')}
      </div>

      <div className="invited-by">
        {invitedBy ? (
          <span>
            {i18n.t('upcomingBookings.INVITED_BY')} 
            {' '}
            {invitedBy}
          </span>
        ) : (
          ''
        )}
      </div>
      <hr />
      <SlotInfo date={ time } clubName={ clubName } address={ clubAddress } />
      <div className="court-type">
        <strong>
          {courtType} 
          {' '}
          {i18n.t('upcomingBookings.COURT')}
        </strong>
      </div>
      <div className="bottom-card-text" onClick={ openCancellationConfirmModal }>
        {i18n.t('myDeuceScreen.CANCEL_COURT')}
        <FontAwesome className="arrow-right" name="arrow-right" />
      </div>
    </div>
  </div>
);

UserBookedCourtCardComponent.propTypes = {
  time: PropTypes.string,
  clubName: PropTypes.string,
  clubAddress: PropTypes.string,
  courtType: PropTypes.string,
  openCancellationConfirmModal: PropTypes.func.isRequired,
  invitedBy: PropTypes.string
};

UserBookedCourtCardComponent.defaultProps = {
  time: '',
  clubName: '',
  clubAddress: '',
  courtType: '',
  invitedBy: ''
};

export default UserBookedCourtCardComponent;



// WEBPACK FOOTER //
// ./src/components/UserBookedCourtCardComponent.js